import { Box, Dialog, Divider, Typography, useTheme } from '@mui/material';
import { ContactEditorForm } from "./ContactEditorForm";
import { ContactEditorButtons } from "./ContactEditorButtons";

export function ContactEditorModalBase({...params}){
    let isModalOpen = params.isModalOpen
    let toggleModal = params.toggleModal

    let input = params.input
    let setInput = params.setInput
    let handleInput = params.handleInput
    let saveButtonDisabled = params.saveButtonDisabled
    let setSaveButtonDisabled = params.setSaveButtonDisabled

    let confirmationScreenState = params.confirmationScreenState
    let setConfirmationScreenState = params.setConfirmationScreenState

    let isNewContact = params.isNewContact
    let call_sign = params.call_sign
    let market = params.market

    let handleContactChange = params.handleContactChange

    let theme = useTheme()

    const getDialogTitleSx = (confirmationScreenState) => ({
        display: 'flex',
        fontSize: "18px",
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: '512px',
        width: '100%',
        height: confirmationScreenState ? 80 : 50,
        paddingBottom: '0px',
        backgroundColor: confirmationScreenState ? "black" : "#06569D",
        flexDirection: confirmationScreenState ? "column" : "row",
    });

    return (
        <Dialog
            id="dialogMain"
            open={isModalOpen}
            onClose={toggleModal}
            transitionDuration={0}
            sx={{maxWidth:'516px', width:'100%', justifySelf:'center'}}
            slotProps={{
                paper: {
                    sx: {
                        width: "100%",
                        maxWidth: '516px',
                        height: "388px",
                        background: theme.palette.ContactEditor.background,
                        fontSize: "18px",
                        border: "2px solid #000",
                        borderRadius: 0,
                        margin: 0,
                    },
                },
            }}
        >
            <Box id="dialogTitle" sx={getDialogTitleSx(confirmationScreenState)}>
                {confirmationScreenState ? (
                        <>
                            <Typography fontWeight={"bold"} fontSize={'18px'}>Are you sure you want to remove this contact?</Typography>
                            <Typography fontSize={'18px'}>(This cannot be undone)</Typography>
                        </>
                    ) : (
                        <Box id={"dialogTitleInnerBox"} display={'flex'} alignItems={'center'} color={'#FFFFFF'} gap={'20px'} px={'10px'} py={'15px'}>
                            <Typography fontWeight={'bold'} fontSize={'18px'}>Contact Editor</Typography>
                            <Divider orientation={"vertical"} flexItem sx={{borderColor:"#5189BAF"}}/>
                            <Typography fontSize={'18px'}>{call_sign}</Typography>
                            <Divider orientation={"vertical"} flexItem sx={{borderColor:"#5189BAF"}}/>
                            <Typography fontSize={'18px'}>{market}</Typography>
                        </Box>
                    )
                }
            </Box >

            <ContactEditorForm
                input={input}
                handleInput={handleInput}
                confirmationScreenState={confirmationScreenState}
            />

            <ContactEditorButtons
                toggleModal={toggleModal}
                confirmationScreenState={confirmationScreenState}
                setConfirmationScreenState={setConfirmationScreenState}
                saveButtonDisabled={saveButtonDisabled}
                setSaveButtonDisabled={setSaveButtonDisabled}
                handleInput={handleInput}
                input={input}
                setInput={setInput}
                isNewContact={isNewContact}
                handleContactChange={handleContactChange}
            />
        </Dialog >
    )
}
